// Sin créditos en el Chat (ADR-2026-10-12-sin-creditos-en-el-chat). Mismo patrón que los
// videos fuera del plan (`videosSegunPlan.ts`): el modelo sabe el saldo ANTES de contestar,
// así no arma una propuesta que después choca, y una herramienta silenciosa cuelga del
// mensaje el botón «Sumar créditos» (abre el catálogo de planes y créditos de la app).

import type { V2Tool } from '../pages/v2/agentTools';

export const NOMBRE_SUMAR_CREDITOS = 'ofrecer_sumar_creditos';

/** Debajo de esto el saldo se nombra con advertencia y viaja la herramienta del botón. */
export const SALDO_BAJO = 10;

export const HERRAMIENTA_SUMAR_CREDITOS: V2Tool = {
  name: NOMBRE_SUMAR_CREDITOS,
  description:
    'Muestra en el chat el botón «Sumar créditos», que abre los planes y paquetes de créditos. Usala cuando lo que pide cuesta más créditos de los que le quedan. No cuesta nada y no escribe texto: el texto lo ponés vos, en una o dos frases.',
  input_schema: { type: 'object', properties: {} },
};

/** ¿Viaja la herramienta del botón? Sólo con el saldo conocido y bajo. */
export function ofreceSumarCreditos(restantes: number | null): boolean {
  return restantes !== null && restantes < SALDO_BAJO;
}

/** Lo que va al volátil del turno. Vacío si el saldo no se pudo leer. */
export function avisoDeSaldo(restantes: number | null): string {
  if (restantes === null) return '';
  const n = Math.max(0, Math.floor(restantes * 100) / 100);
  if (n < 1) {
    return (
      `\n\nCRÉDITOS: a esta cuenta le quedan ${n} créditos: no alcanza para ninguna imagen ni video. ` +
      'Si pide algo que cobra: NO digas que lo vas a hacer, NO armes la propuesta ni la tarjeta. ' +
      `Decí en una o dos frases que se quedó sin créditos, llamá a ${NOMBRE_SUMAR_CREDITOS} para mostrar el botón, ` +
      'y seguí ayudando con lo que no cobra (ideas, textos, planear la sesión).'
    );
  }
  if (n < SALDO_BAJO) {
    return (
      `\n\nCRÉDITOS: a esta cuenta le quedan ${n} créditos. Si lo que pide cuesta más que eso, decíselo ANTES de proponer ` +
      `(con el costo), llamá a ${NOMBRE_SUMAR_CREDITOS} y ofrecé una versión que entre en el saldo (menos imágenes, otra calidad).`
    );
  }
  return `\n\nCRÉDITOS: le quedan ${n}.`;
}
